@if (showFormError) {
  <div class="error tw-mt-1.5 tw-py-2 tw-pr-5 tw-text-xs tw-text-primary empty:tw-hidden">
    @if (control?.errors?.['required'] || control?.errors?.['whitespace']) {
      @if (inputName) {
        {{ 'common.fieldIsRequired' | translate: { field: inputName } }}
      } @else {
        {{ messageForRequired | translate }}
      }
    }
    @if (control?.errors?.['pattern'] || control.errors?.['mask']) {
      @if (control?.errors?.['pattern']?.requiredPattern == defaultEmailPattern) {
        {{ 'common.invalidEmailAddress' | translate }}
      } @else {
        {{ messageForInvalidFormat | translate }}
      }
    }
    @if (control?.errors?.alreadyExists) {
      {{ messageForInputExists | translate: { field: inputName } }}
    }
    @if (control?.errors?.minlength) {
      {{
        messageForMinLength
          | translate: { field: inputName, count: control?.errors?.minlength?.requiredLength }
      }}
    }
    @if (control?.errors?.maxlength) {
      {{
        messageForMaxLength
          | translate: { field: inputName, count: control?.errors?.maxlength?.requiredLength }
      }}
    }
    @if (control?.errors?.notMatch) {
      {{ messageForNotMatch | translate }}
    }
    @if (control?.errors?.['matDatepickerMin']) {
      {{ 'common.incorrectDate' | translate }}
    }
    @if (control?.errors?.['phoneInvalidFormat']) {
      {{ 'common.incorrectPhoneNoFormat' | translate }}
    }
  </div>
}
